import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Button from 'components/common/Button/Button'
import Banner from 'components/common/Banner/Banner'
import { Input } from 'components/common/FormElements/Input'
import { Form, Instructions, Title, Field } from '../components/Recovery/ForgotPages.styles'
import { getSuccessfulMessage } from './helpers'

const ForgotPasswordLockedWrapper = ({
  form,
  email,
  title = 'Recover Password',
  description,
  submitting,
  submitSucceeded,
  handleSubmit,
  handleClose
}) =>
  <ForgotPasswordLockedForm data-at-forgot-password-locked-form noValidate onSubmit={ handleSubmit }>
    {
      submitSucceeded ?
        <React.Fragment>
          <ForgotTitle data-at-title headline size={ 30 }>THANK YOU!</ForgotTitle>
          <Instructions >{ getSuccessfulMessage(email) }</Instructions>
          <Button full="mobile" onClick={ handleClose }>CONTINUE</Button>
        </React.Fragment> :
        <React.Fragment>
          <ForgotTitle data-at-title headline size={ 30 }>{ title }</ForgotTitle>
          <Banner data-at-banner error_alternative>{ description }</Banner>
          <div>
            <Field { ...form.email } full="mobile" component={ Input } />
          </div>
          <Button data-at-send stacked full disabled={ submitting }>Send</Button>
          <Button data-at-cancel stacked full link type="button" onClick={ handleClose }>Cancel</Button>
        </React.Fragment>
    }
  </ForgotPasswordLockedForm>

ForgotPasswordLockedWrapper.propTypes = {
  description: PropTypes.string,
  email: PropTypes.string,
  error: PropTypes.string,
  forgotPasswordInstructions: PropTypes.string,
  form: PropTypes.shape({
    email: PropTypes.shape()
  }),
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitSucceeded: PropTypes.bool,
  submitting: PropTypes.bool,
  title: PropTypes.string
}

export default ForgotPasswordLockedWrapper

const ForgotPasswordLockedForm = styled(Form)`
  width: 100%;
  padding: 0;
`

const ForgotTitle = styled(Title)`
  ${Media.mobile`
    margin-top: 0;
  `}
`.withComponent('h1')
